/**
 * Ops UI layout. Wraps the shared `LayoutShell` with ops-ui's nav structure
 * (Partner / Integration Operations / Config Management). Diaper / Sessions
 * pages and "Data Lab" live in the diaper-ui app now.
 */
import React from 'react';
import { LayoutShell, NavSection, NavItem } from '@nova-integration/ui-shared';
import { useAuthStore } from '../stores/authStore';
import { useEnvironmentStore } from '../stores/environmentStore';
import { AppSwitcher } from './AppSwitcher';

interface LayoutProps {
  children: React.ReactNode;
  fullWidth?: boolean;
}

const partnerItems: NavItem[] = [
  { id: 'partner-dashboard', label: 'My Partner', path: '/partner', anyCapability: ['partner.config.read.own'] },
  { id: 'partner-test-events', label: 'Test Events', path: '/partner/test-events', anyCapability: ['partner.testevents.send.own'] },
];

const opsItems: NavItem[] = [
  { id: 'dashboard', label: 'Dashboard', path: '/' },
  { id: 'live-monitor', label: 'Live Monitor', path: '/live-monitor', anyCapability: ['ops.events.read.all'] },
  { id: 'delivery-log', label: 'Delivery Log', path: '/delivery-log', anyCapability: ['ops.events.read.all'] },
  {
    id: 'mock-partner-monitor',
    label: 'Mock PARTNER Monitor',
    path: '/mock-partner-monitor',
    anyCapability: ['ops.events.read.all'],
  },
  { id: 'rabbitmq', label: 'RabbitMQ', path: '/rabbitmq', anyCapability: ['ops.queue.read'] },
  { id: 'audit', label: 'Audit Log', path: '/audit', anyCapability: ['admin.audit.read'] },
  { id: 'users', label: 'Users', path: '/users', anyCapability: ['admin.users.crud'] },
];

const configItems: NavItem[] = [
  { id: 'cfg-sources', label: 'Source Systems', path: '/configuration/sources', anyCapability: ['admin.sources.crud'] },
  { id: 'cfg-accounts', label: 'Nova Accounts', path: '/configuration/accounts', anyCapability: ['admin.accounts.crud'] },
  { id: 'cfg-tenants', label: 'Tenants', path: '/configuration/tenants', anyCapability: ['ops.tenants.assign'] },
  { id: 'cfg-partners', label: 'Partners', path: '/configuration/partners', anyCapability: ['ops.partners.read.all'] },
];

const navSections: NavSection[] = [
  { id: 'partner', title: 'Partner', items: partnerItems },
  { id: 'ops', title: 'Integration Operations', items: opsItems },
  { id: 'config', title: 'Config Management', items: configItems },
];

const footerNav: NavItem[] = [{ id: 'help', label: 'Help', path: '/help' }];

export const Layout: React.FC<LayoutProps> = ({ children, fullWidth }) => (
  <LayoutShell
    branding={{ title: 'Nova Control Center' }}
    navSections={navSections}
    footerNav={footerNav}
    appSwitcher={<AppSwitcher />}
    useAuthStore={useAuthStore}
    useEnvironmentStore={useEnvironmentStore}
    fullWidth={fullWidth}
  >
    {children}
  </LayoutShell>
);
